<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 127 120"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M83.906 40.0642C77.053 32.1631 72.2293 22.1822 77.526 4.8568C82.3382 -10.8841 91.2198 15.2357 96.2325 32.032C96.5327 33.0378 98.0777 32.9151 98.2216 31.876C99.5062 22.5976 102.297 7.99378 106.374 7.68159C111.105 7.3193 109.574 27.3069 108.188 35.8138C108.102 36.3417 108.458 36.8335 108.977 36.9784C116.481 39.0708 131.378 52.5932 125.763 64.1774C121.4 73.1782 108.192 76.1349 104.807 76.7551C104.344 76.8398 104.002 77.2214 103.999 77.6872C103.973 82.2588 104.249 105.374 112.226 118.47C112.628 119.129 112.161 120 111.384 120H99.2015C98.8163 120 98.4679 119.769 98.3097 119.421C89.9249 100.983 66.3013 94.7745 50.3243 103.579C49.5428 104.009 49.803 105.11 50.6929 105.196L50.7898 105.206C61.3705 106.237 78.1586 107.873 66.7566 119.7C66.5781 119.885 66.3178 120 66.0594 120H10.8698C10.4606 120 10.0956 119.744 9.96414 119.36C8.84551 116.094 7.99171 112.885 7.38006 109.739C7.27224 109.184 6.71079 108.839 6.14982 108.939C3.78096 109.364 0.349327 109.156 0.0231003 104.934C-0.296088 100.804 2.75925 99.845 5.06062 100.023C5.67285 100.071 6.27418 99.6162 6.3182 99.0095C10.0607 47.4288 43.0896 50.169 66.7016 52.128C71.2084 52.5019 75.3721 52.8473 78.9236 52.7812C79.0943 52.778 79.2538 52.7287 79.3989 52.6394C84.2231 49.6712 88.3352 46.6569 83.906 40.0642ZM109.682 53.3724C110.745 53.3724 111.606 52.519 111.606 51.4663C111.606 50.4135 110.745 49.5601 109.682 49.5601C108.619 49.5601 107.758 50.4135 107.758 51.4663C107.758 52.519 108.619 53.3724 109.682 53.3724Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'icon-rabbit',
};
</script>

<style scoped>

</style>
